import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren, ChangeDetectorRef} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalDismissReasons, NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ApplicationSource} from '../../business-entities/application-source';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { Filter } from '../../business-entities/Filter';
import { FuelType, VehicleStatusModel } from '../../business-entities/fuel-view-model';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { BrandType, VehicleListViewModel, VehicleTransmission,VehicleType } from '../../business-entities/vehicle-list-view-model';
import { VehicleListRequestModel } from '../../business-entities/vehicleList-request-model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { BrandService } from '../../business-services/brand.service';
import { CheckListBusinessService } from '../../business-services/check-list.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { RentalCarService } from '../../business-services/rental-car.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { NgbdSortableHeader, SortEvent} from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleBusinessService } from './../../business-services/vehicle-service';


@Component({
  selector: 'app-deleted-vehicles',
  templateUrl: './deleted-vehicles.component.html'
  
})
export class DeletedVehiclesComponent implements OnInit {
//#region variables and models declaration
  isAdvanceSearch: any;
  vehicleStatusList: VehicleStatusModel[] = [];
  vehicleTypes: VehicleType[] = [];
  makeList: BrandType[] = [];
  vehicleList: VehicleListViewModel[];
  applicationSourceList: ApplicationSource[] = [];
  fuels: FuelType[] = [];
  vehicleTransmissionList: VehicleTransmission[] = [];
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Vehicle,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Vehicle,
  };
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  total$: Observable<number>;
  paginationSub: Subscription;
  subscription : Subscription;
  userRoleRightsDetails: UserRoleMenu;
  brandList: BrandViewModel[];
  licensePlateClass: string;
  popupCloseResult = false;
  currentUser: string;
  closeResult: string;
  selectedSync: number;
  control = new FormControl();
  pager: any = {};
  totalCount: number = 0;
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  searchTerm: string = '';
  integrationWithDMS: boolean = false;
  SyncList: StatusViewModel[] = [];
  endDate: string;
  vehicleListRequest: VehicleListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 10,
            sortColumn: '',
            sortDirection: '',
            isForDocuments: false,
            licensePlate: '',
            companyMakeName: null,
            registrationDate: '',
            color: '',
            year: null,
            chassisNo: '',
            fuelType: null,
            sourceOfCreation: null,
            vehicleType: null,
            vehicleGroup: null,
            transmission: null,
            syncId: 0,
            isdeleted : true,
        }
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  throttle = 100;
  scrollDistance = 1;
  //#endregion

  //#region constructor definations
  constructor(
    private service: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    private brandService: BrandService,
    private userService: UserDataService,
    private globalSetting: GlobalSetting,
    private modalService: NgbModal,
    private checkListService: CheckListBusinessService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private secureStorage: SecureStorage,
    private EditRentalCar: RentalCarService,
    private applicationSourceService: ApplicationSourceService,
    private transmissionService: VehicleBusinessService,
    private advanceSearchService: AdvanceSearchService,
    private dashboardService: DashboardService,
    private _eref: ElementRef,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private currentLanguageService: CurrentLanguage,
    config: NgbModalConfig
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }
  //#endregion

  //#region OnInit
  ngOnInit() {
    this.endDate = Utility.GetFormattedDate(new Date());
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.vehicleListRequest.startRecordNumber = 0;
    this.vehicleList = []
    this.applicationSourceService.getFeatures();
    this.getBrands().then(() => {
      this.getVehicleList();
    });
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.userService.currentUserSubject.subscribe((res) => {
      if (res) {
        this.userRoleRightsDetails = (res.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.VehicleDelete);
      }
    });
    this.vehicleList = [];
    this.vehicleListRequest.syncId = Enums.DmsSync.All;
  }
  //#endregion

  //#region Api methos
  async GetAllVehicleStatus(): Promise<void> {
    await this.EditRentalCar.GetAllVehicleStatus().then(data => {
      this.vehicleStatusList = data.responseObject.result.slice();
    });
  }
  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    });
  }
  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
  }
  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = data.responseObject;
      this.applicationSourceList = this.applicationSourceList.filter(source => source.sourceName != 'Dwo');
    });
  }
  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuels = data.responseObject.result.slice();
    });
  }
  async GetVehicleTransmission(): Promise<void> {
    await this.transmissionService.GetVehicleTransmissionDropdownList().then(data => {
      this.vehicleTransmissionList = data.responseObject;
    });
  }
  
  async getVehicleList() {
    this.spinner.show();
    this.vehicleListRequest.chassisNo = !this.empty(this.vehicleListRequest.chassisNo) ? this.vehicleListRequest.chassisNo : null;
    this.vehicleListRequest.color = !this.empty(this.vehicleListRequest.color) ? this.vehicleListRequest.color : null;
    this.vehicleListRequest.sourceOfCreation = !this.empty(this.vehicleListRequest.sourceOfCreation) ? this.vehicleListRequest.sourceOfCreation : null;
    this.vehicleListRequest.companyMakeName = !this.empty(this.vehicleListRequest.companyMakeName) ? this.vehicleListRequest.companyMakeName : null;
    this.vehicleListRequest.fuelType = !this.empty(this.vehicleListRequest.fuelType) ? this.vehicleListRequest.fuelType : null;
    this.vehicleListRequest.licensePlate = !this.empty(this.vehicleListRequest.licensePlate) ? this.vehicleListRequest.licensePlate : null;
    this.vehicleListRequest.transmission = !this.empty(this.vehicleListRequest.transmission) ? this.vehicleListRequest.transmission : null;
    this.vehicleListRequest.vehicleGroup = !this.empty(this.vehicleListRequest.vehicleGroup) ? this.vehicleListRequest.vehicleGroup : null;
    this.vehicleListRequest.vehicleType = !this.empty(this.vehicleListRequest.vehicleType) ? this.vehicleListRequest.vehicleType : null;
    this.vehicleListRequest.year = !this.empty(this.vehicleListRequest.year) ? this.vehicleListRequest.year : 0;
    this.vehicleListRequest.syncId = !this.empty(this.vehicleListRequest.syncId) ? this.vehicleListRequest.syncId : 0;
    const temp = new Date();
    if (!this.empty(this.vehicleListRequest.registrationDate)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.vehicleListRequest.registrationDate).getTime() - (temp.getTimezoneOffset() * 60000));
      this.vehicleListRequest.registrationDate = registerdate.toLocaleDateString();
    } else {
      this.vehicleListRequest.registrationDate = "";
    }
    await this.service.getVehicleList(this.vehicleListRequest).then((response) => {
      this.spinner.hide();
      this.vehicleList.push(...this.VehicleDataMapper(response.vehicleLists));
      if (response.result?.errorCode == "4004") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.vehicleList.length > 0 ? this.vehicleList[0].totalCount : 0;
      }
    }, _error => {
      this.spinner.hide();
    });
  }
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve()
      });
    })
  }
  async HardDeleteVehicle(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblHardDeleteVehicle"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.currentUser = this.userService.currentUserValue.userId;
        let deleteRequestModel = { id: id, UserId: this.currentUser };
        this.service.HardDeleteVehicle(deleteRequestModel).then((response) => {
          this.vehicleList = [];
          this.getVehicleList();
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblVehicleDeleted");
            this.toaster.success(successMsg)
          }
        });
      }
    })
  }
  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.Vehicle).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(val => {
              val.searchActualValue = val.searchValue;
            });
          });
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }
  //#endregion

  //#region Other methods
  onRefresh() {
    this.vehicleList = [];
    this.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }
  RemoveFilter() {
    const VehicleListRequestModel =
    {
      searchTerm: '',
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      isForDocuments: false,
      licensePlate: '',
      companyMakeName: null,
      registrationDate: '',
      color: '',
      year: null,
      chassisNo: '',
      fuelType: null,
      sourceOfCreation: null,
      vehicleType: null,
      vehicleGroup: null,
      transmission: null,
      syncId: 0
    }
    this.vehicleListRequest = VehicleListRequestModel;
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.vehicleListRequest.sortColumn = column;
    this.vehicleListRequest.sortDirection = direction;
    this.vehicleListRequest.searchTerm = null
    this.vehicleList = [];
    this.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }
  onSearchFilter() {
    this.vehicleList = [];
    this.vehicleListRequest.startRecordNumber = 0;
    this.vehicleListRequest.searchTerm = this.searchTerm;
    this.getVehicleList();
  }
  onReset() {
    this.resetVariables();
    this.getVehicleList();
  }
  resetVariables() {
    this.vehicleList = [];
    this.vehicleListRequest.startRecordNumber = 0;
    this.vehicleListRequest.licensePlate = '';
    this.vehicleListRequest.companyMakeName = null;
    this.vehicleListRequest.registrationDate = '';
    this.vehicleListRequest.color = '';
    this.vehicleListRequest.year = null;
    this.vehicleListRequest.chassisNo = '';
    this.vehicleListRequest.fuelType = null;
    this.vehicleListRequest.sourceOfCreation = null;
    this.vehicleListRequest.vehicleType = null;
    this.vehicleListRequest.vehicleGroup = null;
    this.vehicleListRequest.transmission = null;
    this.vehicleListRequest.licensePlate = null;
  }
  onClose() {
    this.isAdvanceSearch = false;
  }
  onSearch() {
    if (this.vehicleStatusList.length == 0) {
      this.GetAllVehicleStatus();
    }
    if (this.vehicleTypes.length == 0) {
      this.GetAllVehicleTypes();
    }
    if (this.makeList.length == 0) {
      this.GetAllMake();
    }
    if (this.applicationSourceList.length == 0) {
      this.GetApplicationSource();
    }
    if (this.fuels.length == 0) {
      this.GetAllFuelTypes();
    }
    if (this.vehicleTransmissionList.length == 0) {
      this.GetVehicleTransmission();
    }
    this.cdr.detectChanges();
    this.isAdvanceSearch = true;
    this.cdr.detectChanges();
  }
  AdvanceSearchSubmit() {
    this.vehicleList = []
    this.vehicleListRequest.searchTerm = this.searchTerm;
    this.vehicleListRequest.startRecordNumber = Constant.startRecordNumber;
    this.getVehicleList();
    this.isAdvanceSearch = false;
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }
  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  SyncChange(status: any) {
    if (status == undefined) {
      this.vehicleListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.vehicleListRequest.syncId = status;
    }
    this.vehicleList = [];
    this.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }
  onScrollDown(_ev: any) {
    if (this.totalCount > this.vehicleList.length) {
      this.vehicleListRequest.startRecordNumber = this.vehicleList.length;
      this.getVehicleList();
    }

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  //#endregion
  
  //#region  Data mapping and Save models
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && (event.target.className.indexOf('ng-option') == -1 && event.target.parentElement.className.indexOf('ng-option') == -1 && event.target.className.indexOf('btn') == -1)) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  private VehicleDataMapper(service: VehicleListViewModel[]) {
    let supperArray = [];
    if (service && service.length > 0) {
      for (let index = 0; index < service.length; index++) {
        const element = service[index];

        const single = Object();
        single.rowNumber =
          this.vehicleListRequest.startRecordNumber + 1 + index;
        single.id = element.id;
        single.vehicleId = element.vehicleId;
        single.licensePlate = element.licensePlate;
        single.engineSerialNo = element.engineSerialNo;
        single.companyMakeCode = element.companyMakeCode;
        single.companyModel = element.companyModel;
        single.companyMakeName = element.companyMakeName;
        single.mchCode = element.mchCode;
        single.registrationDate = element.registrationDate;
        single.color = element.color;
        single.year = element.year;
        single.chassisNo = element.chassisNo;
        single.fuelType = element.fuelType;
        single.vehicleGroup = element.vehicleGroup;
        single.vehicleType = element.vehicleType;
        single.dmsSyncStatus = element.dmsSyncStatus;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.logo = element.companyMakeCode
          ? this.getBrandImage(element.companyMakeCode)
          : null;
        element.sourceOfCreation = element.sourceOfCreation == "Admin" ? "Planner" : element.sourceOfCreation;
        single.sourceOfCreation = element.sourceOfCreation
          ? element.sourceOfCreation
          : '';
        single.vehicleType = element.vehicleType;
        single.totalCount = element.totalCount
        supperArray.push(single);
      }
    }

    return supperArray;
  }
  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toaster.error(ErrorMsg);
    }
  }
  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;

    if (this.vehicleListRequest.licensePlate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblRegistrationNumber",
        searchValue: this.vehicleListRequest.licensePlate,
        searchActualValue: this.vehicleListRequest.licensePlate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.companyMakeName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMake",
        searchValue: this.vehicleListRequest.companyMakeName,
        searchActualValue: this.vehicleListRequest.companyMakeName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.registrationDate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblRegistrationFirstDate",
        searchValue: this.vehicleListRequest.registrationDate,
        searchActualValue: this.vehicleListRequest.registrationDate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.color) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblColor",
        searchValue: this.vehicleListRequest.color,
        searchActualValue: this.vehicleListRequest.color
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.year > 0) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblYear",
        searchValue: this.vehicleListRequest.year.toString(),
        searchActualValue: this.vehicleListRequest.year.toString()
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.chassisNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVinNumber",
        searchValue: this.vehicleListRequest.chassisNo,
        searchActualValue: this.vehicleListRequest.chassisNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.fuelType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblFuelType",
        searchValue: this.vehicleListRequest.fuelType,
        searchActualValue: this.vehicleListRequest.fuelType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.vehicleListRequest.sourceOfCreation,
        searchActualValue: this.vehicleListRequest.sourceOfCreation
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.vehicleType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVehicalType",
        searchValue: this.vehicleListRequest.vehicleType,
        searchActualValue: this.vehicleListRequest.vehicleType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.vehicleGroup) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVehicleStatus",
        searchValue: this.vehicleListRequest.vehicleGroup,
        searchActualValue: this.vehicleListRequest.vehicleGroup
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.vehicleListRequest.transmission) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblTransmission",
        searchValue: this.vehicleListRequest.transmission,
        searchActualValue: this.vehicleListRequest.transmission
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
  }
  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toaster.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toaster.success(successMsg);
        this.modalService.dismissAll();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toaster.error(errorMsg);
      }
    });
  }
  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalRef = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalRef.componentInstance.isFromAppointment = false;
      modalRef.componentInstance.searchList = this.savedSearchListResponse;
      modalRef.componentInstance.onReset.subscribe((_data) => {
        this.onReset();
      });
      modalRef.componentInstance.onEditOrRun.subscribe((data) => {
        if (data.isRun) {
          this.resetVariables();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalRef.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data, modalRef);
      });
    });
  }
  OnDeleteSaveSearch(searchName, outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(() => outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toaster.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toaster.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toaster.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toaster.error(errorMessage);
          }

        });
      }
    });
  }
  ApplySaveSearch(data, isRunSearch) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        saveSearchDetail[0].saveSearchArray.forEach(element => {
          switch (element.searchColumnName) {
            case 'lblRegistrationNumber':
              this.vehicleListRequest.licensePlate = element.searchValue;
              break;
            case 'lblVehicleStatus':
              this.vehicleListRequest.vehicleGroup = element.searchValue;
              break;
            case 'lblVehicalType':
              this.vehicleListRequest.vehicleType = element.searchValue;
              break;
            case 'lblMake':
              this.vehicleListRequest.companyMakeName = element.searchValue;
              break;
            case 'lblVinNumber':
              this.vehicleListRequest.chassisNo = element.searchValue;
              break;
            case 'lblRegistrationFirstDate':
              this.vehicleListRequest.registrationDate = element.searchValue;
              break;
            case 'lblSource':
              this.vehicleListRequest.sourceOfCreation = element.searchValue;
              break;
            case 'lblColor':
              this.vehicleListRequest.color = element.searchValue;
              break;
            case 'lblFuelType':
              this.vehicleListRequest.fuelType = element.searchValue;
              break;
            case 'lblTransmission':
              this.vehicleListRequest.transmission = element.searchValue;
              break;
            case 'lblYear':
              this.vehicleListRequest.year = parseInt(element.searchValue);
              break;
            default:
              break;
          }
        });
      }
      if (isRunSearch) {
        if (this.vehicleListRequest.registrationDate) {
          this.vehicleListRequest.registrationDate = this.vehicleListRequest.registrationDate.replace(/\//g, ".");
        }
        this.AdvanceSearchSubmit();
      }
      else {
        this.onSearch();
        this.activeModal.dismiss();
      }
    }
  }
  //#endregion
}
